import { ReactNode } from "react"
import {
  AccordionButton,
  AccordionButtonProps,
  AccordionIcon,
  AccordionIconProps,
  AccordionItem as ChakraAccordionItem,
  AccordionItemProps as ChakraAccordionItemProps,
  AccordionPanel,
  AccordionPanelProps,
} from "@chakra-ui/react"

export type AccordionItemProps = {
  title: ReactNode
  children: ReactNode
  showIcon?: boolean
  accordionItemProps?: ChakraAccordionItemProps
  accordionButtonProps?: AccordionButtonProps
  accordionIconProps?: AccordionIconProps
  accordionPanelProps?: AccordionPanelProps
}

export default function AccordionItem({
  title,
  children,
  showIcon = true,
  accordionItemProps,
  accordionButtonProps,
  accordionIconProps,
  accordionPanelProps,
}: AccordionItemProps) {
  return (
    <ChakraAccordionItem {...accordionItemProps}>
      <AccordionButton {...accordionButtonProps}>
        {title}
        {showIcon && <AccordionIcon {...accordionIconProps} />}
      </AccordionButton>
      <AccordionPanel {...accordionPanelProps}>{children}</AccordionPanel>
    </ChakraAccordionItem>
  )
}
